module.exports = __webpack_public_path__ + "media/images/plans/wedding_reception/hall-list/plan-wedding-lineup-kanto-1-d26d326a72f932e3000f05657e5a97b7.jpg";